import { useCallback, useEffect, useRef, useState } from 'react';

export function useTableMaxHeight(hideFooter) {
  const containerRef = useRef(null);
  const footerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  const calculateMaxHeight = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const footerHeight = hideFooter
      ? 0
      : footerRef.current?.getBoundingClientRect().height || 0;

    const tablePage = container.closest('.table-page');
    let bottomSpacing = 0;

    if (tablePage) {
      const styles = window.getComputedStyle(tablePage);
      bottomSpacing += parseFloat(styles.paddingBottom) || 0;
      bottomSpacing += parseFloat(styles.marginBottom) || 0;
    }

    const availableHeight =
      window.innerHeight - rect.top - footerHeight - bottomSpacing;

    setMaxHeight(availableHeight > 0 ? availableHeight : null);
  }, [hideFooter]);

  useEffect(() => {
    calculateMaxHeight();
    window.addEventListener('resize', calculateMaxHeight);

    const tablePage = containerRef.current?.closest('.table-page');
    const targets = [
      tablePage,
      tablePage?.querySelector('.table-filters'),
      tablePage?.querySelector('.page-heading'),
    ].filter(Boolean);

    const observer = new ResizeObserver(calculateMaxHeight);
    targets.forEach((el) => observer.observe(el));

    return () => {
      window.removeEventListener('resize', calculateMaxHeight);
      observer.disconnect();
    };
  }, [calculateMaxHeight]);

  return { containerRef, footerRef, maxHeight };
}
